export default "__VITE_ASSET__BirDSiGf__"